export const GET_RESERVATION_CART_REQUEST = 'GET_RESERVATION_CART_REQUEST';
export const GET_RESERVATION_CART_REQUESTING =
  'GET_RESERVATION_CART_REQUESTING';
export const GET_RESERVATION_CART_SUCCESS = 'GET_RESERVATION_CART_SUCCESS';
export const UPDATE_RESERVATION_CART_REQUEST =
  'UPDATE_RESERVATION_CART_REQUEST';
export const RESET_RESERVATION_CART_ISFETCHING =
  'RESET_RESERVATION_CART_ISFETCHING';
export const PROCESS_RESERVATION_CART_REQUEST =
  'PROCESS_RESERVATION_CART_REQUEST';
export const CREATE_RESERVATION_CART_REQUEST =
  'CREATE_RESERVATION_CART_REQUEST';
export const UPDATE_AND_PROCESS_RESERVATION_CART_REQUEST =
  'UPDATE_AND_PROCESS_RESERVATION_CART_REQUEST';
export const RESERVATION_CHECKOUT_STEP_REQUEST =
  'RESERVATION_CHECKOUT_STEP_REQUEST';
export const RESERVATION_CHECKOUT_STEP_REQUEST_GTM =
  'RESERVATION_CHECKOUT_STEP_REQUEST_GTM';
export const CHARGE_RESERVATION_CART_SUCCESS_GTM =
  'CHARGE_RESERVATION_CART_SUCCESS_GTM';
